import { createFileRoute } from '@tanstack/react-router';

import { WorkOrderGridView } from '../../../features/cost-to-produce/work-order-grid-view';
import { usePartnerId } from '../../../features/inbox/use-partner-name';

export const Route = createFileRoute('/operating-costs/cost-to-produce/work-order')({
  staticData: { breadcrumb: 'Work Order' },
  component: WorkOrderTab,
});

function WorkOrderTab() {
  const partnerId = usePartnerId();
  return <WorkOrderGridView partnerId={partnerId} />;
}
